import { computed, unref } from 'vue'
import { useDisplay } from 'vuetify'

export function useMobileSm() {
    const display = useDisplay();

    return computed(() => {
      return unref(display.sm)
    });
}